<template>
  <div class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">{{ id ? 'Edit Survey' : 'Create Survey' }}</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-3">
            <label class="dado__label">Survey Language</label>
            <v-select :options="getLangOptions" :flags="true" :value="lang" :search="true" @input="lang = $event"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="polls">
          <div class="dado__higher" v-if="id">
            <div class="dado__pick block d-block cursor-pointer" @click="onSurveyChangeStatus" v-if="getSurveyForm.status">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0625 6.60938H12.7956V3.71848C12.7956 1.66809 11.0923 0 8.9987 0C6.90511 0 5.20182 1.66809 5.20182 3.71848V6.60938H3.9375C2.77439 6.60938 1.82812 7.55564 1.82812 8.71875V15.8906C1.82812 17.0537 2.77439 18 3.9375 18H14.0625C15.2256 18 16.1719 17.0537 16.1719 15.8906V8.71875C16.1719 7.55564 15.2256 6.60938 14.0625 6.60938ZM6.60807 3.71848C6.60807 2.4435 7.68052 1.40625 8.9987 1.40625C10.3169 1.40625 11.3893 2.4435 11.3893 3.71848V6.60938H6.60807V3.71848ZM14.7656 15.8906C14.7656 16.2783 14.4502 16.5938 14.0625 16.5938H3.9375C3.5498 16.5938 3.23438 16.2783 3.23438 15.8906V8.71875C3.23438 8.33105 3.5498 8.01562 3.9375 8.01562H14.0625C14.4502 8.01562 14.7656 8.33105 14.7656 8.71875V15.8906Z"
                      fill="white"/>
                <path d="M9 10.0547C8.28158 10.0547 7.69922 10.6371 7.69922 11.3555C7.69922 11.8142 7.93687 12.2171 8.29557 12.4488V13.9922C8.29557 14.3805 8.61036 14.6953 8.9987 14.6953C9.387 14.6953 9.70182 14.3805 9.70182 13.9922V12.4504C10.062 12.2191 10.3008 11.8153 10.3008 11.3555C10.3008 10.6371 9.71842 10.0547 9 10.0547Z"
                      fill="white"/>
              </svg>
              Unpublish
            </div>
            <div class="dado__pick permit d-block cursor-pointer" @click="onSurveyChangeStatus" v-if="!getSurveyForm.status">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path d="M14.0625 6.60938H6.60807V3.71848C6.60807 2.4435 7.68052 1.40625 8.9987 1.40625C10.3169 1.40625 11.3893 2.4435 11.3893 3.71848V5.0625H12.7956V3.71848C12.7956 1.66809 11.0923 0 8.9987 0C6.90511 0 5.20182 1.66809 5.20182 3.71848V6.60938H3.9375C2.77439 6.60938 1.82812 7.55564 1.82812 8.71875V15.8906C1.82812 17.0537 2.77439 18 3.9375 18H14.0625C15.2256 18 16.1719 17.0537 16.1719 15.8906V8.71875C16.1719 7.55564 15.2256 6.60938 14.0625 6.60938ZM14.7656 15.8906C14.7656 16.2783 14.4502 16.5938 14.0625 16.5938H3.9375C3.5498 16.5938 3.23438 16.2783 3.23438 15.8906V8.71875C3.23438 8.33105 3.5498 8.01562 3.9375 8.01562H14.0625C14.4502 8.01562 14.7656 8.33105 14.7656 8.71875V15.8906Z"
                        fill="white"/>
                  <path d="M9 10.0547C8.28158 10.0547 7.69922 10.6371 7.69922 11.3555C7.69922 11.8142 7.93687 12.2171 8.29557 12.4488V13.9922C8.29557 14.3805 8.61036 14.6953 8.9987 14.6953C9.387 14.6953 9.70182 14.3805 9.70182 13.9922V12.4504C10.062 12.2191 10.3008 11.8153 10.3008 11.3555C10.3008 10.6371 9.71842 10.0547 9 10.0547Z"
                        fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="18" height="18" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              Publish
            </div>
            <div class="dado__pick xls d-block cursor-pointer" @click="onSurveyCopy">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path d="M7.3126 10.3125H8.2501V12.75C8.2501 13.164 8.5861 13.5 9.0001 13.5C9.4141 13.5 9.7501 13.164 9.7501 12.75V10.3125H10.6876C11.1871 10.3125 11.4384 9.70575 11.0851 9.3525L9.3976 7.665C9.2881 7.55475 9.1441 7.5 9.0001 7.5C8.8561 7.5 8.7121 7.55475 8.6026 7.665L6.9151 9.3525C6.56185 9.70575 6.8131 10.3125 7.3126 10.3125Z"
                        fill="white"/>
                  <path d="M11.25 16.5H6.75C5.92275 16.5 5.25 15.8273 5.25 15V14.25C5.25 13.836 5.586 13.5 6 13.5C6.414 13.5 6.75 13.836 6.75 14.25V15H11.25V14.25C11.25 13.836 11.586 13.5 12 13.5C12.414 13.5 12.75 13.836 12.75 14.25V15C12.75 15.8273 12.0772 16.5 11.25 16.5Z"
                        fill="white"/>
                  <path d="M15.75 15.1875H14.625C14.2102 15.1875 13.875 14.8515 13.875 14.4375C13.875 14.0235 14.2102 13.6875 14.625 13.6875H15.75C16.164 13.6875 16.5 13.3507 16.5 12.9375V5.25C16.5 4.83675 16.164 4.5 15.75 4.5H7.6875C7.488 4.5 7.2975 4.42125 7.15725 4.28025L5.877 3H2.25C1.836 3 1.5 3.33675 1.5 3.75V12.9375C1.5 13.3507 1.836 13.6875 2.25 13.6875H3.375C3.78975 13.6875 4.125 14.0235 4.125 14.4375C4.125 14.8515 3.78975 15.1875 3.375 15.1875H2.25C1.0095 15.1875 0 14.178 0 12.9375V3.75C0 2.5095 1.0095 1.5 2.25 1.5H6.1875C6.387 1.5 6.5775 1.57875 6.71775 1.71975L7.998 3H15.75C16.9905 3 18 4.0095 18 5.25V12.9375C18 14.178 16.9905 15.1875 15.75 15.1875Z"
                        fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="18" height="18" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              Copy
            </div>
            <div class="dado__pick delete d-block cursor-pointer" @click="onSurveyDelete" v-if="!getSurveyForm.status">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                      fill="white"/>
                <path d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                      fill="white"/>
                <path d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                      fill="white"/>
                <path d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                      fill="white"/>
              </svg>
              Delete
            </div>
          </div>
          <div class="questions__set">
            <div class="questions__box">
              <div class="row">
                <div class="col-12 col-md-8">
                  <div class="questions__topic">Survey title</div>
                  <div class="questions__square">
                    <input type="text" placeholder="Type here..." v-model="getSurveyForm.title[lang]" class="form__field" :readonly="getSurveyForm.status"/>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <label class="questions__topic mb-0">Country</label>
                  <div class="questions__square">
                    <vue-select v-model="getSurveyForm.country_id" :options="getCountriesOptions()" label="name" :disabled="getSurveyForm.status"></vue-select>
                  </div>
                </div>
              </div>
              <div class="questions__btn mt-5" v-if="!getSurveyForm.status">
                <button class="btn" @click="onSurveySubmit">Submit</button>
              </div>
            </div>

            <v-draggable v-model="sortList"
                         draggable=".questions__sort"
                         handle=".handle"
                         @sort="onSortQuestions($event)">
              <div class="questions__sort" v-for="(question, index) of sortList">
                <div class="questions__item position-relative mb-0">
                  <div class="questions__head">
                    <div class="questions__topic">
                      <template v-if="question.type === 'text_block'">
                        <span class='questions__force handle'></span>
                        {{ index + 1 }} - Text block <span class='questions__tale'></span>
                      </template>
                      <template v-else>
                        <span class='questions__force handle' v-if="!getSurveyForm.status"></span>
                        {{ index + 1 }} - Question <span class='questions__tale'></span>
                      </template>
                    </div>
                    <div class="questions__singly" v-if="!getSurveyForm.status">
                      <div class="questions__setting" @click="onShowEditQuestionModal(question)"></div>
                      <div class="questions__del" @click="onDeleteQuestion(question)"></div>
                    </div>
                  </div>
                  <div class="questions__mass">
                    <div class="questions__output">
                      <template v-if="question.type === 'text_block'">
                        <span class='questions__bill questions__bill_text'>!</span>
                      </template>
                      <template v-else>
                        <span class='questions__bill' v-if="getNumberQuestion(question)" v-html="getNumberQuestion(question)"></span>
                      </template>
                      <span>{{ getQuestionTypes[question.type] }}</span>
                    </div>
                    <div class="questions__matter text_with_n">{{ question.text[lang] || question.text['en'] }}</div>

                    <!--Dictionary-->
                    <div v-if="question.answers_dictionary && question.answers_dictionary.type">
                      <small class="text-muted">
                        Reference: <b>{{ question.answers_dictionary.type == 'scopes' ? 'crops' : question.answers_dictionary.type }}</b>
                        <span v-if="question.answers_dictionary.countries_id.length">
                          ({{ getCountriesName(question.answers_dictionary.countries_id).join(', ') }})
                        </span>
                      </small>
                    </div>

                    <!--answers of previews question-->
                    <div v-if="['single', 'multiple', 'sort'].includes(question.type) && question.answers_previous_question">
                      <small class="text-muted">
                        Answer options include the answers from the question № <b>{{ getNumberQuestionForId(question.answers_previous_question) }}</b>
                      </small>
                    </div>

                    <!--organ systems-->
                    <div v-if="question.view_conditions.organsystems.length">
                      <small class="text-muted">
                        Organ Systems: <b>{{ getQuestionOrganSystems(question) }}</b>
                      </small>
                    </div>

                    <!--show if answer selected in the preview question-->
                    <div v-if="question.view_conditions.previous_question && question.view_conditions.previous_question_answers && question.view_conditions.previous_question_answers.length">
                      <small class="text-muted">
                        Showed if: <b>{{ getConditionPreviousQuestion(question) }}</b>
                      </small>
                    </div>

                    <!--answers-->
                    <div class="questions__checkbox" v-if="!question.answers_dictionary || question.answers_dictionary.type == null">
                      <div v-for="answer of question.answers">
                        <template v-if="question.type === 'single'">
                          <input :id="'answer' + answer.id" :name="'qwestion'+question.id" type="radio" class="test__radio"/>
                          <label :for="'answer' + answer.id" class="test__label">
                            {{ answer.text[lang] || answer.text['en'] }}
                            <span v-if="isStopedAnswer(question.stop_answers, answer.id)" class="text-danger pl-1">- stopped survey</span>
                            <img v-if="question.image_answers" class="img-thumbnail mb-2" :src="answer.image" style="height: 150px"/>
                          </label>
                        </template>

                        <label class="checkbox" v-if="question.type === 'multiple'">
                          <input type="checkbox"/>
                          <span class="checkbox__part">
                            <span class="checkbox__text">
                              {{ answer.text[lang] || answer.text['en'] }}
                              <span v-if="isStopedAnswer(question.stop_answers, answer.id)" class="text-danger pl-1">- stopped survey</span>
                              <img v-if="question.image_answers" class="img-thumbnail mb-2" :src="answer.image" style="height: 150px"/>
                            </span>
                          </span>
                        </label>

                        <label class="checkbox" v-if="question.type === 'sort'">
                          <span class="checkbox__text">
                            <span class='questions__force'></span> {{ answer.text[lang] || answer.text['en'] }}
                          </span>
                        </label>
                      </div>
                    </div>

                    <!--footer-->
                    <div class="questions__extra" v-if="question.type !== 'text_block'">
                      <div class="questions__rubric">Follow-up questions
                        <button v-if="!getSurveyForm.status" class="questions__append d-block text-right">
                          <div class="mb-1" @click="onShowCreateChildrenQuestionModal(question)">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.5 16V1M16 8.5H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            Add sub-question
                          </div>
                          <small class="btn-link font-weight-bold" @click="onShowSelectQuestionModal(question.id)">or link an existing question</small>
                        </button>
                      </div>
                      <div class="questions__kit">
                        <v-draggable v-model="question.childrens"
                                     draggable=".questions__unit"
                                     handle=".handle"
                                     @sort="onSortSubQuestions($event, question.childrens)">
                          <div class="questions__unit" v-for="(sub_question, sub_index) of question.childrens">
                            <div class="questions__head mb-2">
                              <div class="questions__topic">
                                {{ sub_index + 1 }} - Sub Question <span class='questions__tale'></span>
                              </div>
                              <div class="questions__singly" v-if="!getSurveyForm.status">
                                <div class="questions__setting" @click="onShowEditQuestionModal(sub_question)"></div>
                                <div class="questions__del" @click="onDeleteQuestion(sub_question)"></div>
                              </div>
                            </div>
                            <div v-if="!getSurveyForm.status" class="questions__alter handle"></div>
                            <div class="questions__output">
                              <span class='questions__bill' v-if="getNumberQuestion(sub_question)">{{ getNumberQuestion(sub_question) }} </span>
                              <span>{{ getQuestionTypes[sub_question.type] }}</span>
                            </div>
                            <div class="questions__matter">{{ sub_question.text[lang] }}</div>
                            <div v-if="sub_question.answers_dictionary && sub_question.answers_dictionary.type">
                              <small class="text-muted">
                                Reference: <b>{{ sub_question.answers_dictionary.type }}</b>
                              </small>
                            </div>
                            <div class="questions__checkbox sub_answer">
                              <div v-for="sub_answer of sub_question.answers">
                                <template v-if="sub_question.type === 'single'">
                                  <input :id="'sub_answer' + sub_answer.id" :name="'question'+sub_question.id" type="radio" class="test__radio"/>
                                  <label :for="'sub_answer' + sub_answer.id" class="test__label">
                                    {{ sub_answer.text[lang] || sub_answer.text['en'] }}
                                  </label>
                                </template>

                                <label class="checkbox" v-if="sub_question.type === 'multiple'">
                                  <input type="checkbox"/>
                                  <span class="checkbox__part">
                                    <span class="checkbox__text">
                                      {{ sub_answer.text[lang] || sub_answer.text['en'] }}
                                    </span>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </v-draggable>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-3 position-relative" @mouseover="hover = question.id" @mouseleave="hover = false">
                  <button class="plus-btn" v-if="hover == question.id && !getSurveyForm.status" @click="onShowCreateSelectModal(question)">+</button>
                </div>
              </div>
            </v-draggable>
          </div>
          <div class="questions__box mb-0" v-if="!getSurveyForm.status">
            <div class="questions__topic">
              <span class='questions__add'></span>Add a new question or <a href="" @click.prevent="onShowSelectQuestionModal()">link an existing question</a>
            </div>
            <div class="questions__output">Сhoose the type of question</div>
            <div class="questions__select">
              <vue-select :options="questionTypeOptions" v-model="questionType" @change="onShowCreateQuestionModal($event)"></vue-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'SurveyForm',
    props: ['id'],
    data() {
      return {
        lang: 'en',
        questionType: null,
        sortList: [],
        hover: false
      }
    },
    computed: {
      ...mapGetters([
        'getQuestionTypes',
        'getOrgansystems',
        'getDraftQuestions',
        'getLangOptions',
        'getCountriesOptions',
        'getSurveyForm',
        'getCountriesName',
        'getPublicSurvayFromRegion',
      ]),
      addedQuestionIds() {
        let ids = []
        for (let question of this.sortList) {
          if (question.use_question_id)
            ids.push(question.use_question_id)

          for (let sub_question of question.childrens)
            if (sub_question.use_question_id)
              ids.push(sub_question.use_question_id)
        }
        return ids
      },
      questionTypeOptions() {
        let arr = []
        for (let type in this.getQuestionTypes)
          arr.push({id: type, text: this.getQuestionTypes[type]})
        return arr
      },
    },
    watch: {
      getSurveyForm(val) {
        this.sortList = val.questions
      },
      getDraftQuestions(val) {
        this.sortList = val
      }
    },
    mounted() {
      if (this.id) {
        this.querySurvey(this.id)
        this.sortList = this.getSurveyForm.questions
      } else {
        this.clearSurveyForm()
        this.queryDraftQuestions()
        this.sortList = this.getDraftQuestions
      }
      this.queryCountries()
      this.queryOrgansystems()
    },
    methods: {
      ...mapActions([
        'queryDraftQuestions',
        'querySurvey',
        'clearSurveyForm',
        'queryCountries',
        'storeSurvey',
        'copySurvey',
        'updateSurvey',
        'destroySurvey',
        'sortableQuestions',
        'deleteQuestion',
        'queryQuestionAnswers',
        'queryOrgansystems',
        'setToast',
        'showModal',
      ]),

      onSurveyChangeStatus() {
        let status = 0
        if (!this.getSurveyForm.status) {
          status = 1
          if (this.getPublicSurvayFromRegion(this.getSurveyForm.country_id)) {
            this.$confirm({
              message: 'There is already a published study for the selected region. If you continue, he will be removed from publication.',
              callback: confirm => {
                if (confirm)
                  this.updateSurvey([this.getPublicSurvayFromRegion(this.getSurveyForm.country_id), {status: 0}])
                    .then(() => {
                      this.updateSurvey([this.id, {status: status}])
                    })
                else
                  return false
              }
            })
          } else {
            this.updateSurvey([this.id, {status: status}])
          }
        } else {
          this.updateSurvey([this.id, {status: status}])
        }
      },
      onSurveyCopy() {
        this.copySurvey(this.getSurveyForm.id)
      },
      onSurveyDelete() {
        this.$confirm({
          message: 'Delete poll ' + this.getSurveyForm.title[this.lang] + '?',
          callback: confirm => {
            if (confirm) {
              this.destroySurvey(this.getSurveyForm.id)
              this.$router.push('/surveys')
            }
          }
        })
      },
      onSurveySubmit() {
        if (!this.getSurveyForm.title['en']) {
          this.setToast({status: 'warning', message: 'Title field cannot be empty'})
          return false
        }
        if (!this.getSurveyForm.country_id) {
          this.setToast({status: 'warning', message: 'Country field cannot be empty'})
          return false
        }
        if (this.id) {
          this.updateSurvey([
              this.id,
              {
                title: this.getSurveyForm.title,
                country_id: this.getSurveyForm.country_id,
              }
            ]
          )
        } else {
          this.storeSurvey(
            {
              title: this.getSurveyForm.title,
              country_id: this.getSurveyForm.country_id,
            }
          )
        }
      },

      onShowCreateSelectModal(question) {
        this.showModal({
          modal: 'ModalCreateQuestion',
          data: {
            sort: question.sort,
            addedQuestionIds: this.addedQuestionIds,
            sortList: this.sortList,
            poll_id: this.getSurveyForm.id,
          }
        })
      },

      onShowCreateQuestionModal(val, sort) {
        if (!sort) {
          let sort = 0
          if (this.sortList.length)
            sort = parseInt(this.sortList[this.sortList.length - 1].sort) + 1
        }
        if (this.id) {
          this.showModal({
            modal: 'ModalSurveyQuestion',
            data: {
              poll_id: this.id,
              type: val,
              sort: sort
            }
          })
        } else {
          this.showModal({
            modal: 'ModalSurveyQuestion',
            data: {
              is_draft: true,
              type: val,
              sort: sort
            }
          })
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.questionType = null
          }, 500)
        })
      },
      onShowCreateChildrenQuestionModal(question) {
        let sort = 0
        if (question.childrens.length)
          sort = parseInt(question.childrens[question.childrens.length - 1].sort) + 1
        if (this.id)
          this.showModal({modal: 'ModalSurveyQuestion', data: {poll_id: this.id, parent_id: parseInt(question.id), type: 'single', sort: sort}})
        else
          this.showModal({modal: 'ModalSurveyQuestion', data: {is_draft: true, parent_id: parseInt(question.id), type: 'single', sort: sort}})
      },
      onShowEditQuestionModal(question) {
        this.showModal({modal: 'ModalSurveyQuestion', data: question})
      },
      onShowSelectQuestionModal(parent_id) {
        let data = {
          added_base_questions: this.addedQuestionIds
        }
        if (parent_id)
          data.parent_id = parent_id
        if (this.sortList.length)
          data.sort = parseInt(this.sortList[this.sortList.length - 1].sort) + 1
        if (this.id)
          data.poll_id = this.id
        else
          data.is_draft = true
        this.showModal({modal: 'ModalSelectSurveyQuestion', data: data})
      },
      onDeleteQuestion(question) {
        this.$confirm({
          message: 'Delete question ' + question.text[this.lang] + '?',
          callback: confirm => {
            if (confirm)
              this.deleteQuestion(question)
          }
        })
      },

      onSortQuestions(event) {
        this.sortList.splice(event[0], 0, this.sortList.splice(event[1], 1)[0])
        this.sortableQuestions(this.sortList)
      },
      onSortSubQuestions(event, questions) {
        questions.splice(event[1], 0, questions.splice(event[0], 1)[0])
        this.sortableQuestions(questions)
      },

      isStopedAnswer(stop_answers, answer_id) {
        stop_answers = JSON.parse(JSON.stringify(stop_answers))
        if (stop_answers) {
          for (let i = 0; i < stop_answers.length; i++) {
            if (stop_answers[i] == answer_id)
              return true
          }
        }
        return false
      },
      getNumberQuestion(question) {
        let number = false
        if (typeof question.number !== undefined)
          number = question.number
        if (question.parent && typeof question.parent.number !== undefined)
          number = question.parent.number
        if (number && number.length > 3)
          number = '<small>' + number + '</small>'
        return number
      },
      getNumberQuestionForId(question_id) {
        for (let question of this.getSurveyForm.questions)
          if (question.id == question_id)
            return this.getNumberQuestion(question)
        return null
      },
      getQuestionOrganSystems(question) {
        let array = []
        for (let item in question.view_conditions.organsystems) {
          let os_id = question.view_conditions.organsystems[item]
          for (let os of this.getOrgansystems)
            if (os_id == os.id)
              array.push(os.name[this.lang] ? os.name[this.lang] : os.name['en'])
        }
        return array.join(', ')
      },
      getConditionPreviousQuestion(question) {
        let question_number = null
        let answers = []
        for (let item of this.sortList) {
          if (item.id == question.view_conditions.previous_question) {
            question_number = item.number
            for (let answ of item.answers)
              if (question.view_conditions.previous_question_answers.includes(answ.id.toString()))
                answers.push(answ.text[this.lang] ? answ.text[this.lang] : answ.text['en'])
          }
        }
        if (question_number)
          return 'Question #' + question_number + ': ' + answers.join(', ')
        return ''
      }
    }
  }
</script>

<style scoped>
  .test__label:after { left: 47px !important }

  .questions__unit { padding: 28px 28px 28px 30px !important }

  .sub_answer .test__label:after { left: 37px !important }

  .plus-btn {
    position: absolute;
    right: 20px;
    top: -45px;
    z-index: 9999;
    background: #fff;
    border: none;
    border-radius: 35px;
    padding: 6px 24px;
    font-size: 42px;
    box-shadow: 0 0 20px #dddcdc;
    height: 70px;
    line-height: 55px;
  }

  .plus-btn:focus { outline: 0; }
</style>